"use strict";

$.widget("fotobook.plainTextBaseColorWidget", $.fotobook.baseColorWidget, {
    currentColorBar: null,
    "options" : {
        "disabledClass" : "disabled",
        "attribute" : "",
        "cssProperty" : "",
    },
    _create: function(){
        this._super();
        this.currentColorBar = $("<div>", {
            "class" : "current-color-bar",
        });
        this.element.append(this.currentColorBar);
        this._updateWidget(this._getColorFromProject());
    },
    _getColorSourceElement: function(){
        return this.options.editorWidget._getTextContent();
    },
    _getColorFromProject: function(){
        return this._getColorSourceElement().attr(this.options.attribute);
    },
    _colorPickerOpen: function(color){
        this.options.editorWidget._clearContentEditable();
        this._super();
    },
    _updateWidget: function(color){
        this.currentColorBar.css("background-color", color);
    },
    _colorPickerSetColor: function(color){
        this._getColorSourceElement().css(this.options.cssProperty, color).attr(this.options.attribute, color);
        this._updateWidget(color);
    },
    _colorPickerClose: function(color){
        if (this.options.editorWidget){
            this.options.editorWidget._setContentEditable();
        }
        this._super();
    },
    _destroy: function(){
        this._super();
        this.currentColorBar.remove();
    },
});

$.widget("fotobook.plainTextFontColorWidget", $.fotobook.plainTextBaseColorWidget, {
    "options" : {
        "attribute" : "data-fcolor",
        "cssProperty" : "color",
    },
});

$.widget("fotobook.spineBackgroundColorWidget", $.fotobook.plainTextBaseColorWidget, {
    "options" : {
        "attribute" : "data-bgcolor",
        "cssProperty" : "background-color",
    },
    _checkEnabled: function(){
        return $(document.documentElement).hasClass("foto-clipart");
    },
    _colorPickerSetColor: function(color){
        this._super(color);
        this.options.editorWidget._copySpine();
    },
});

$.widget("fotobook.spineFontColorWidget", $.fotobook.plainTextBaseColorWidget, {
    "options" : {
        "attribute" : "data-fcolor",
        "cssProperty" : "color",
    },
    _colorPickerSetColor: function(color){
        this._super(color);
        this.options.editorWidget._copySpine();
    },
});

